import { BASE_BACKEND_URL, fetchWithAuth } from '../../../auth'
import { useEffect, useRef, useState } from 'react'
import { DEFAULT_DATA } from '../constants/ocConstants'


const useFetchOcOverview = (ocId, isError = false) => {
  const abortControllerRef = useRef(null)

  const [data, setData] = useState(DEFAULT_DATA)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchOverview = async () => {
    abortControllerRef.current?.abort()

    const controller = new AbortController()
    abortControllerRef.current = controller

    try {
      setLoading(true)
      setError(null)

      const url = isError
        ? `${BASE_BACKEND_URL}/poc/purchase_orders/${ocId}`
        : `${BASE_BACKEND_URL}/poc/orders/${ocId}`

      const response = await fetchWithAuth(url, {
        signal: controller.signal
      })

      setData(response ?? DEFAULT_DATA)
    } catch (err) {
      if (err.name !== 'AbortError') {
        setError(err)
      }
    } finally {
      setLoading(false)
      abortControllerRef.current = null
    }
  }

  useEffect(() => {
    if (!ocId) return

    fetchOverview()

    return () => {
      abortControllerRef.current?.abort()
    }
  }, [ocId, isError])

  return {
    data,
    loading,
    error,
    refetch: fetchOverview
  }
}
export default useFetchOcOverview
